import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import IxBottomNav from '../../basic/ix-bottom-nav';
import NxtTopBar from '../../basic/nxt-top-bar';
import NxtCartSummary from './nxt-cart-summary';
import IxTxtBox from '../../basic/ix-txt-box';
import NxtTopBarItems from '../../composite/nxt-top-bar-items';
import companyConfigEnum from '../../../constants/company-config-enum';
import { redirectToSearch, dateAndTimeGenerator } from '../../../services/utility';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import NxtPriceDisplay from '../../composite/nxt-price-display';
import TakeoutBottomFunction from '../../basic/takeout-bottom-function';
import {
  ORDER_DETAIL_CHARGE,
  ORDER_DETAIL_TOTAL
} from '../../basic/nxt-text-apart';

const useStyles = makeStyles(theme => ({
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgb(0 0 0 / 10%)',
    borderTop: '1px solid rgb(0 0 0 / 10%)'
  },
  orderName: {
    fontSize: '1.1rem',
    fontWeight: 400
  },
  choiceType: {
    color: 'rgb(127,129,149)',
    fontSize: '.9rem',
    fontWeight: 400,
    whiteSpace: 'nowrap'
  },
  orderTime: {
    color: 'rgb(166 172 175)'
  },
  orderPrice: {
    fontWeight: 900,
    color: '#000000'
  },
  listItemSecondColumn: {
    textAlign: 'right'
  },
  time: {
    '& .MuiTypography-colorTextPrimary': {
      color: '#ffffff'
    }
  },
  secondTopBar: {
    marginTop: '50px',
    height: '10vh',
    background: '#7E7C7B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '16px',
    paddingRight: '32px'
  },
  timePortion: {
    display: 'flex'
  },
  calenderIcon: {
    color: '#ffffff',
    opacity: '0.5',
    paddingRight: '1rem'
  },
  listContainer: {
    overflowY: 'auto',
    height: '70vh'
  }
}));

const TakeoutOrderDetailList = props => {
  const classes = useStyles();
  let orderId = props?.match?.params?.orderId;
  
  const { history, menuState, fetchOrderDetails } = props;
  const orderDetailData = menuState.orderDetails.data;
  const orderItems = orderDetailData?.orderMenus?.map(menu=>menu.orderItems);
  const languageCode = useSelector((state) => state.language.code);
  const { t, i18n } = useTranslation(['common']);

  const TkAmount = [
    { label: t('Subtotal'), amount: orderDetailData?.subTotal },
    { label: t('Tax')+` (${orderDetailData?.takeAwayTaxPercentage}%)`, amount: orderDetailData?.takeAwayTax }
  ];

  useEffect(() => {
    fetchOrderDetails(orderId)
  },[])

  const orderItemChoices = (choices) => {
    let orderChoiceArray = choices.map(choice => choice.name[languageCode])
    let commaSeparatedChoices = orderChoiceArray.join();
    return commaSeparatedChoices;
  }

  const orderStatus = status => {
    if (status?.pickupStatus === 'COMPLETED') {
      return t('Completed');
    } else if (status?.pickupStatus === 'PENDING') {
      return t('Pending');
    } else {
      return t('Ready for pick up');
    }
  };


  const nameGenerator = (item) =>{
    if(languageCode === 'en-US') {
      return item?.name['en-US'];
    }
  }


  return (
    <div>
      <div>
        <NxtTopBar>
          <NxtTopBarItems
            title={t('Order')+` #${orderDetailData?.displayOrderNo}`}
            titleAlignment='left'
            handleSearchButton={() => redirectToSearch(history)}
          ></NxtTopBarItems>
        </NxtTopBar>
      </div>

      <div className={classes.secondTopBar}>
        <div className={classes.timePortion}>
          <InsertInvitationIcon className={classes.calenderIcon} />
          <IxTxtBox
            primary={dateAndTimeGenerator(orderDetailData)}
            primaryVariant='h6'
            className={classes.time}
          ></IxTxtBox>
        </div>
        <IxTxtBox
          primary={orderStatus(orderDetailData)}
          primaryVariant='h6'
          className={classes.time}
        ></IxTxtBox>
      </div>

      <div className={classes.listContainer}>
        {orderItems && orderItems?.map((order, i) => (
          
          order.map((item,i) => (<div className={classes.listItem}>
            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderName,
                  secondary: classes.choiceType
                }}
                primary={item.name[languageCode]}
                secondary={orderItemChoices(item?.orderItemChoices)}
              />
            </ListItem>

            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderTime,
                  secondary: classes.orderPrice
                }}
                className={classes.listItemSecondColumn}
                primary={`${item.quantity} ${t('serving')}`}
                secondary={`￥${item.payable}`}
              />
            </ListItem>
          </div>
          ))
        ))}

        {TkAmount.map((e, i) => (
          <NxtCartSummary
            title={e.label}
            value={e.amount}
            orderDetailStyle={ORDER_DETAIL_CHARGE}
            // value={0}
          />
        ))}

        <NxtCartSummary
          title={t('Total')}
          value={orderDetailData?.totalDecimal}
          orderDetailStyle={ORDER_DETAIL_TOTAL}
          // value={0}
        />
      </div>

      <Grid container direction='column'>
        <TakeoutBottomFunction
          history={history}
          rightChildText={t('OrderAgainBtnText')}
          leftBtnLink={t('Close')}
          rightBtnLink={'/pickup-time-selection'}
          orderDetail={true}
        ></TakeoutBottomFunction>
      </Grid>
    </div>
  );
};

export default TakeoutOrderDetailList;
